<template>
  <div>
    <h2 class="text-xl font-extrabold text-center">{{ title }}</h2>
    <ScoreSelector v-if="showScore" v-model="score" @change="change" :legend-min="legendMin"
                   :legend-max="legendMax"></ScoreSelector>
    <template v-if="extra || !showScore">
      <div class="text-lg font-bold" v-if="questionMore">{{ questionMore }}</div>
      <div v-if="!questionMore">&nbsp;</div>
      <textarea class="bg-input border rounded w-full border-gray-100 px-2 py-2" rows="6"
                :placeholder="questionMoreAnswerPlaceholder" v-model="more" @blur="change"/>
    </template>
  </div>
</template>

<script>
import ScoreSelector from '@/components/ScoreSelector'

export default {
  name: 'SurveyQuestion',
  components: { ScoreSelector },
  props: {
    title: {},
    questionId: {},
    questionMore: {},
    questionMoreAnswerPlaceholder: {},
    modelValue: {},
    initialValue: {
      default: null
    },
    legendMin: {
      default: null
    },
    legendMax: {
      default: null
    },
    showScore: {
      default: true
    }
  },
  data () {
    return {
      score: null,
      more: null
    }
  },
  watch: {
    initialValue (newValue) {
      this.score = newValue
    }
  },
  computed: {
    extra () {
      if (this.score == null) {
        return false
      }
      return this.score < 8
    }
  },
  created () {
    if (this.initialValue) {
      this.score = this.initialValue
      this.change()
    }
  },
  methods: {
    change () {
      let value = {
        'score': this.score,
        'more': this.more,
        'questionId': this.questionId
      }
      if (!this.showScore) {
        value.score = -1
      }
      this.$emit('update:modelValue', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="css">

</style>
